import React, { useEffect } from 'react';
import clsx from 'clsx';
import styles from '@components/catalog/my-sizes/my-sizes/editing/editing.module.scss';
import Icon from '@components/atoms/icon/icon';
import { useTranslation } from 'next-i18next';

interface EditingPopupMenuProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onClose: () => void;
}

const EditingPopupMenu: React.FC<EditingPopupMenuProps> = ({ onClick, onClose }) => {
  const deletePopupRef = React.useRef<HTMLButtonElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    deletePopupRef.current?.focus();
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Escape') {
      e.stopPropagation();
      e.preventDefault();
      onClose();
    }
  };

  return (
    <button
      ref={deletePopupRef}
      className={clsx(styles.popupDeleteBtn, styles['popupDeleteBtn--show'])}
      onClick={onClick}
      type="button"
      onBlur={onClose}
      onKeyDown={handleKeyDown}
    >
      <Icon
        name="trash-can"
        className={styles.popupDeleteBtn__icon}
        ariaHidden
      />
      {t('PLP.MYSIZES_DIALOG.DELETE_BUTTON')}
    </button>
  );
};

export default EditingPopupMenu;
